import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { TransportSeatsForm } from './TransportSeatsForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allResorts } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj transport' : 'Dodaj transport'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <TransportSeatsForm data={data} submitCallback={submitCallback} handleClose={handleClose} allResorts={allResorts} />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
